import { BroadcastsRoutePath } from '@/types/router/path/broadcasts';
import { HomeRoutePath } from '@/types/router/path/home';
import { LivestreamRoutePath } from '@/types/router/path/livestreams';
import { MuslimHubRoutePath } from '@/types/router/path/muslim-hub';
import { PresentersRoutePath } from '@/types/router/path/presenters';
import { QuranTutorsRoutePath } from '@/types/router/path/quran-tutors';
import { UsersRoutePath } from '@/types/router/path/users';
import {
    PhLayout,
    PhUsers,
    PhGear,
    PhBroadcast,
    PhIdentificationCard,
    PhBellSimple,
    PhChalkboardTeacher,
    PhIdentificationBadge
} from '@phosphor-icons/vue';

export const menuDefault = [
    {
        path: '/',
        icon: PhLayout,
        label: 'Beranda',
        group: 'home',
        permission: '*.*'
    },
    {
        path: LivestreamRoutePath.Livestreams,
        icon: PhBroadcast,
        label: 'Kelola Siaran Ngaji',
        group: 'livestreams',
        permission: '*.*'
    },
    {
        path: PresentersRoutePath.Presenters,
        icon: PhIdentificationCard,
        label: 'Profil Pemateri',
        group: 'presenters',
        permission: '*.*'
    },
    {
        path: UsersRoutePath.Users,
        icon: PhUsers,
        label: 'Data Pengguna',
        group: 'users',
        permission: '*.*'
    },
    // {
    //     path: '/transactions',
    //     icon: PhCreditCard,
    //     label: 'Transaksi',
    //     group: 'transactions'
    // },
    // {
    //     path: '/bookmarks/verses',
    //     icon: PhBookBookmark,
    //     label: 'Konten Sahabat Ngaji',
    //     group: 'bookmarks',
    //     child: [
    //         {
    //             path: '/bookmarks/verses',
    //             label: 'Ayat',
    //             sub: 'verses'
    //         },
    //         {
    //             path: '/bookmarks/hadiths',
    //             label: 'Hadist',
    //             sub: 'hadiths'
    //         },
    //         {
    //             path: '/bookmarks/duas',
    //             label: 'Doa Pendek',
    //             sub: 'duas'
    //         },
    //     ]
    // },
    {
        path: MuslimHubRoutePath.Registration,
        icon: PhIdentificationBadge,
        label: 'Kreator Muslim Hub',
        group: 'muslim-hub',
        child: [
            {
                path: MuslimHubRoutePath.Registration,
                label: 'Pendaftaran Creator',
                sub: 'registration',
                permission: 'hub-creator.registration.manage'
            },
            {
                path: MuslimHubRoutePath.ActivityApproval,
                label: 'Pengajuan Kegiatan',
                sub: 'activity-approval',
                permission: 'hub-agenda.validation.manage'
            },
            {
                path: MuslimHubRoutePath.AreaApproval,
                label: 'Pengajuan Tempat',
                sub: 'area-approval',
                permission: 'hub-agenda.validation.manage'
            },
            {
                path: MuslimHubRoutePath.CreatorManagement,
                label: 'Manajemen Creator',
                sub: 'creator-management',
                permission: 'hub-creator.management.manage'
            }
        ]
    },
    {
        path: QuranTutorsRoutePath.Registration,
        icon: PhChalkboardTeacher,
        label: 'Sahabat Guru Ngaji',
        group: 'quran-tutors',
        child: [
            {
                path: '/quran-tutors/list',
                label: 'Daftar Guru Ngaji',
                sub: 'list',
                permission: '*.*'
            },
            {
                path: QuranTutorsRoutePath.Registration,
                label: 'Pendaftaran Guru Ngaji',
                sub: 'registration',
                permission: 'volunteer.registration.manage'
            },
            {
                path: QuranTutorsRoutePath.InstructorRegistration,
                label: 'Pendaftaran Pengajar',
                sub: 'instructor-registration',
                permission: 'volunteer.registration.manage'
            },
            {
                path: QuranTutorsRoutePath.TeachingVideos,
                label: 'Video Mengajar',
                sub: 'teaching-videos',
                permission: '*.*'
            },
            {
                path: QuranTutorsRoutePath.ValidateActivity,
                label: 'Validasi Kegiatan Ngaji',
                sub: 'validate-activity',
                permission: 'volunteer.activity-validation.manage'
            },
            {
                path: QuranTutorsRoutePath.Incentive,
                label: 'Insentif Guru Ngaji',
                sub: 'incentive',
                permission: '*.*'
            },
            {
                path: QuranTutorsRoutePath.Disbursement,
                label: 'Penyaluran Dana',
                sub: 'disbursement',
                permission: '*.*'
            }
        ]
    },
    // {
    //     path: DonationsRoutePath.Donations,
    //     icon: PhWallet,
    //     label: 'Laporan Donasi',
    //     group: 'donations',
    //     permission: '*.*'
    // },
    {
        path: BroadcastsRoutePath.Broadcasts,
        icon: PhBellSimple,
        label: 'Manajemen Notifikasi',
        group: 'broadcasts',
        permission: '*.*'
    }
];

export const menuProfile = [
    {
        path: HomeRoutePath.Home,
        icon: PhGear,
        label: 'Settings',
        group: 'setting',
        permission: '*.*'
    }
];
